import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";

export type PrimaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * Our main CTA button.
 * 
 * The component is a simple wrapper around the `.primary-button` CSS class.
 * 
 * @status stable
 */
export const PrimaryButton: React.FC<PrimaryButtonProps> = ({ className, ...args }) => {
  return (
    <button
      type="button"
      className={classNames("primary-button", className)}
      {...args}
    />
  );
};
